export const DOCS_BASE_URL = (
  import.meta.env.VITE_DOCS_BASE_URL ?? 'https://docs.int.bayer.com/scribbler'
).replace(/\/$/, '')
export const DOCS_SUPPORT_URL = `${DOCS_BASE_URL}/support`
export const TEAMS_CHANNEL_URL =
  import.meta.env.VITE_TEAMS_CHANNEL_URL?.trim() ||
  'https://teams.microsoft.com/l/message/19:_Zs0-Jy43uEGJPjVrIj8gv9x51ZabrPPYjZkWKQpgwQ1@thread.tacv2/1778158351572?tenantId=fcb2b37b-5da0-466b-9b83-0014b67a7c78&groupId=05a1c1ce-fbfb-4e9c-8fa3-9f2cb5f60dee&parentMessageId=1778158351572&teamName=Scribbler&channelName=%E2%84%B9%EF%B8%8F%20Info%20Hub&createdTime=1778158351572'
